<template>
  <v-card class="my-2" v-if="trip">
    <v-card-title class="subtitle-1 card-title-head" @click="expand = !expand">
      <v-icon v-if="!expand">mdi-chevron-right</v-icon>
      <v-icon v-if="expand">mdi-chevron-down</v-icon>
      {{ $i18n.t("Expenses") }}

      <v-spacer />

      <v-btn v-if="
        trip.miscExpense &&
        (!trip.miscExpense.charges || trip.miscExpense.charges.length == 0)
      " @click="
  trip.miscExpense.charges = addNewCharge(trip.miscExpense.charges)
" small style="width: 60px; float: right" color="light-blue" text>
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <v-btn text v-if="!expand && trip.marginString" color="blue"
        v-show="trip.miscExpense && trip.miscExpense.total != null" style="float: right">
        <!--  <strong>{{ $i18n.t("Margin (All Client subtotal - Supplier Amount )") }} :</strong> -->
      <strong>  {{ trip.marginString }}</strong>
      </v-btn>
      <v-btn text v-if="!expand" color="blue lighten-2" v-show="trip.miscExpense && trip.miscExpense.total != null"
        style="width: 60px; float: right">
        <strong>{{ $i18n.t("Total") }} :</strong>
        {{ trip.miscExpense.total }}
      </v-btn>
    </v-card-title>
    <v-expand-transition>
      <v-card-text class="py-0" dense v-if="expand">
        <v-row dense>
          <v-col cols="12" md="12">
            <v-simple-table v-if="trip.miscExpense" dense>
              <thead v-if="trip.miscExpense.charges.length">
                <tr style="background-color: rgb(245 248 248)">
                  <th>{{ $i18n.t("Name") }}</th>
                  <th>{{ $i18n.t("Description") }}</th>
                  <th width="10%">{{ $i18n.t("Unit(s)") }}</th>
                  <th>{{ $i18n.t("Rate") }}</th>
                  <th>{{ $i18n.t("Amount") }}</th>
                  <th>{{ $i18n.t("Action") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in trip.miscExpense.charges" :key="i + 'charge_misc_fare'"
                  style="outline: 1px auto #e8e8e8">
                  <td>
                    <z-name-master-select v-model="item.name" :dense="true" :type="9" label
                      :addNewLabel="'Add Expense Item'" />
                  </td>
                  <td>
                    <v-text-field v-model="item.desc" class="ma-0 pa-0" />
                  </td>
                  <td>
                    <v-text-field v-model="item.units" type="number" class="ma-0 pa-0" @blur="calculateFare" />
                  </td>
                  <td>
                    <v-text-field v-model="item.unitCost" type="number" class="ma-0 pa-0" @blur="calculateFare" />
                  </td>
                  <td>
                    <v-text-field v-model="item.amount" type="number" class="ma-0 pa-0" disabled />
                  </td>
                  <td>
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-btn class="float-left" color="error" x-small fab text dark
                          v-if="item && trip.miscExpense.charges.length > 1"
                          @click="remove(trip.miscExpense.charges, i, true)">
                          <v-icon>mdi-minus-circle</v-icon>
                        </v-btn>
                        <v-btn class="float-left" v-if="
                          item && trip.miscExpense.charges.length == i + 1
                        " @click="
  trip.miscExpense.charges = addNewCharge(
    trip.miscExpense.charges
  )
" text x-small fab color="blue">
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-col cols="12" md="12" sm="12" v-show="trip.miscExpense && trip.miscExpense.total != null"
            class="text-right float-right">
            <ul style="list-style-type: none">
              <li>
                <strong>{{ $i18n.t("Total") }} :</strong>
                {{ trip.miscExpense.total }}
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-card-text>
    </v-expand-transition>
  </v-card>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import common from "@/store/common/module/common";

@Component({
  name: "MiscExpense",
  props: {
    trip: {
      default: null,
    },
  },
})
export default class MiscExpense extends Vue {
  expand = false;
  get loading() {
    return common.loading;
  }

  mounted() {
    if (this.trip) {
      if (!this.trip.miscExpense) this.trip.miscExpense = {};
      if (!this.trip.miscExpense.charges) this.trip.miscExpense.charges = [];
      if (!this.trip.miscExpense.total) this.trip.miscExpense.total = null;
    }
  }

  addNewCharge(itemList) {
    if (!itemList) itemList = [];
    itemList.push({
      name: null,
      desc: null,
      units: 1,
      unitCost: null,
      amount: null,
    });
    return itemList;
  }

  remove(list, _index, calcFare) {
    list.splice(_index, 1);
    if (calcFare) this.calculateFare();
  }

  utilMultiple(val1, val2) {
    let amount = 0;
    val1 = parseFloat(val1);
    val2 = parseFloat(val2);
    if (val1 && !isNaN(val1) && val2 && !isNaN(val2)) amount = val1 * val2;
    else amount = 0;
    return Math.round(amount * 100) / 100;
  }

  utilSum(val1, val2) {
    let amount = 0;
    val1 = parseFloat(val1);
    val2 = parseFloat(val2);
    if (val1 && !isNaN(val1)) amount = amount + val1;
    if (val2 && !isNaN(val2)) amount = amount + val2;
    return Math.round(amount);
  }

  async calculateFare() {
    if (
      this.trip &&
      this.trip.miscExpense &&
      this.trip.miscExpense.charges &&
      this.trip.miscExpense.charges.length > 0
    ) {
      let total = 0;
      for (let _i = 0; _i < this.trip.miscExpense.charges.length; _i++) {
        const charge = this.trip.miscExpense.charges[_i];
        if (charge && charge.units && charge.unitCost) {
          this.trip.miscExpense.charges[_i].amount = this.utilMultiple(
            charge.units,
            charge.unitCost
          );
        }
        total = this.utilSum(this.trip.miscExpense.charges[_i].amount, total);
      }
      this.trip.miscExpense.total = total;
    } else {
      this.trip.miscExpense.total = null;
    }
    this.$root.$emit("reloadMargin");
  }
}
</script>

<style scoped>
.card-title-head {
  background-color: rgb(211, 235, 240);
  height: 40px;
  padding-top: 0px;
  color: #3b7776;
}
</style>
